import './window.js';
import './controllers/windowController.js';
import './directives/windowDirectives.js';
import './services/windowService.js';